import React from 'react';
import { useScope } from '../contexts/ScopeContext';
import {useLocation} from 'react-router-dom';
import {scopePresentation} from '../scope/presentation';
const EnvironmentSelector: React.FC = () => {
  const scope = useScope();
  const ready = scope.registry.kind === 'available';
  const presentation=scopePresentation(useLocation().pathname);
  if(presentation.kind!=='environment')return <div className="text-xs" data-testid="fixed-scope-presentation"><label>{presentation.label} <select aria-label="Environment" disabled value={presentation.kind}><option value={presentation.kind}>{presentation.label}</option></select></label><p role="note">{presentation.reason} Browsing scope retained: {scope.label}.</p></div>;
  return <label className="flex items-center gap-1 text-xs font-semibold" aria-label="Environment scope">
    <span className="sr-only sm:not-sr-only">Environment</span>
    <select aria-label="Environment" className="max-w-[11rem] rounded border border-slate-300 bg-white px-2 py-1.5 text-sm"
      value={scope.resolved.kind === 'all' ? '__all__' : scope.environmentId ?? ''} disabled={!ready}
      onChange={event => scope.setEnvironmentId(event.target.value === '__all__' ? null : event.target.value)}>
      <option value="" disabled>{scope.label === 'Scope unavailable' ? 'Scope unavailable' : 'Select environment'}</option>
      <option value="__all__">All environments · read only</option>
      {scope.registry.kind === 'available' && scope.registry.rows.map(row => <option key={row.environmentId} value={row.environmentId}>{row.name}{row.lifecycle === 'planned' ? ' · planned' : ''}</option>)}
    </select>
  </label>;
};
export default EnvironmentSelector;
